import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  additionalDescription() {
    return faker.lorem.paragraph();
  },

  additionalProductInfo() {
    return faker.lorem.paragraph();
  },

  alternativeHeadline() {
    return faker.music.songName();
  },

  alternativeSubHeadlines() {
    return faker.lorem.words(6);
  },

  artistDescription() {
    return faker.lorem.paragraph();
  },

  catmamaId() {
    return faker.random.numeric(5);
  },

  color() {
    return faker.color.rgb({ prefix: '#' });
  },

  headline() {
    return faker.music.songName();
  },

  isClassicalDiscography() {
    return faker.datatype.boolean();
  },

  repertoireDescription() {
    return faker.lorem.paragraph();
  },

  videoAdsInactive() {
    return faker.datatype.boolean();
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },

  afterCreate(productFamily, server) {
    productFamily.update({
      // artists: server.createList('product-family-contributor', 1),
      categories: server.createList('category', 4),
      // composers: server.createList('product-family-contributor', 1),
      // contributors: server.createList('product-family-contributor', 1),
      products: server.createList('product', 1),
      webSeries: server.createList('web-series', 1),
    });
  },
});
